import { Controller } from "@hotwired/stimulus"

// The King's Mews' glass.
//
// A horse is chosen by coat and mane before it is bought, and the glass
// shows it as it would be, with the keeper up on it, redrawn by the server
// each time a choice changes: the same Sprites::Horse that every room draws,
// so what you see is what they get. The price follows the coat; the buy
// button greys when the hoard will not stretch. Nothing is bought until the
// form's own submit.
export default class extends Controller {
  static targets = [ "preview", "line", "price", "coin", "buy", "short", "natural", "announcer", "name" ]
  static values = { previewUrl: String }

  connect() {
    this.sequence = 0
  }

  choose(event) {
    const input = event.currentTarget
    if (input.name === "horse") {
      const coat = input.closest("[data-horse]")
      const swatch = coat?.querySelector(".ll-coat")
      if (this.hasLineTarget) this.lineTarget.textContent = coat?.getAttribute("title") || ""
      if (this.hasNaturalTarget && swatch) {
        this.naturalTarget.style.background = swatch.style.getPropertyValue("--mane")
      }
      this.reprice(Number(event.params.price), event.params.coin || "silver")
      // The button names what the coin buys, so it never reads as saving a
      // change to a horse already in the stable.
      if (this.hasNameTarget) this.nameTarget.textContent = (event.params.name || "").replace(/^(A|The) /, "the ")
    }
    this.announce(input.name === "horse" ? "The coat" : "The mane", event.params.name)
    this.redraw()
  }

  // A coat is priced in silver or gold (Coin); the purse it is weighed
  // against is the one the coat asks for.
  reprice(price, coin = "silver") {
    if (!this.hasPriceTarget || !this.hasBuyTarget) return
    this.priceTarget.textContent = price
    if (this.hasCoinTarget) this.coinTarget.textContent = coin === "gold" ? "g" : "s"
    const purse = Number(this.buyTarget.dataset[coin] || 0)
    const short = purse < price
    this.buyTarget.disabled = short
    if (this.hasShortTarget) this.shortTarget.hidden = !short
  }

  async redraw() {
    if (!this.hasPreviewTarget) return
    const form = this.element.querySelector("form")
    if (!form) return

    const params = new URLSearchParams()
    for (const [ name, value ] of new FormData(form)) {
      if (name === "horse" || name === "mane") params.set(name, value)
    }

    const sequence = ++this.sequence
    const response = await fetch(`${this.previewUrlValue}?${params}`, { headers: { Accept: "text/html" } })
    if (!response.ok || sequence !== this.sequence) return

    this.previewTarget.innerHTML = await response.text()
  }

  announce(what, name) {
    if (!this.hasAnnouncerTarget) return
    this.announcerTarget.textContent = `${what}: ${name || "chosen"}.`
  }
}
